import { render, staticRenderFns } from "./ProductTypeViewForm.vue?vue&type=template&id=666adfbe&scoped=true&"
import script from "./ProductTypeViewForm.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeViewForm.vue?vue&type=style&index=0&id=666adfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666adfbe",
  null
  
)

export default component.exports